<app-ad-widgets [favorite]="favorite"
                (favoriteChange)="updateAd()"
                [tab]="tab"
                [link]="'/app/favorites/' + favorite.favorite_list.id +'/' + favorite.id +'/' + tab.slug"
                [edit]="edit"
                [custom]="true">
</app-ad-widgets>
